<template>
    <div class="n2-timelines">
        <table class="n2-timeline-table">
            <tr>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.date') }}
            </th>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.operator_type') }}
            </th>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.operator_name') }}
            </th>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.status') }}
            </th>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.action_type') }}
            </th>
            <th class="n2-timeline-item-header">
                {{ $t('components.app.timelines.action_value') }}
            </th>
        </tr>
        <tr v-for="tl in timelines" v-bind:key="tl.id">
            <td class="n2-timeline-item-content">
                {{ formatDate(tl.created_at) }}
            </td>
            <td class="n2-timeline-item-content">
                {{ getOperatorType(tl.operator_type) }}
            </td>
            <td class="n2-timeline-item-content">
                {{ getOperatorName(tl) }}
            </td>
            <td class="n2-timeline-item-content">
                {{ tl.status }}
            </td>
            <td class="n2-timeline-item-content">
                {{ getActionDescription(tl.action_type) }}
            </td>
            <td class="n2-timeline-item-content">
                <div v-if="tl.action_type == 'note_added'">
                    {{ JSON.parse(tl.action_value).note }}
                </div>
                <div v-else-if="tl.action_type == 'leg_fee_applied'">
                    {{ JSON.parse(tl.action_value).request ? JSON.parse(tl.action_value).request.amount : 'N/A' }} NOK
                </div>
                <div v-else-if="tl.action_type == 'fee_applied'">
                    {{ JSON.parse(tl.action_value).request ? JSON.parse(tl.action_value).request.amount : 'N/A' }} NOK
                </div>
                <div v-else-if="tl.action_type == 'refund_issued'">
                    {{ JSON.parse(tl.action_value).request ? JSON.parse(tl.action_value).request.amount : 'N/A' }} NOK
                </div>
                <div v-else-if="tl.action_type == 'ticket_email_sent'">
                    {{ JSON.parse(tl.action_value).request ? JSON.parse(tl.action_value).request.email : 'N/A' }}
                </div>
                <div v-else-if="tl.action_type == 'contact_info_updated'">
                    <div class="n2-text-bold" style="color: red;">
                        <table v-if="JSON.parse(tl.action_value).previous_value">
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.name') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.given_name }}
                                    {{ JSON.parse(tl.action_value).previous_value.middle_name }}
                                    {{ JSON.parse(tl.action_value).previous_value.family_name }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.email') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.email }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.phone_number') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.phone_number }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.address') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.address.address_line_1 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.locality') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.address.locality }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.postal_code') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.address.postal_code }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.country_code') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).previous_value.address.country_code }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="n2-text-bold">
                        <table v-if="JSON.parse(tl.action_value).new_value">
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.name') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.given_name }}
                                    {{ JSON.parse(tl.action_value).new_value.middle_name }}
                                    {{ JSON.parse(tl.action_value).new_value.family_name }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.email') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.email }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.phone_number') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.phone_number }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.address') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.address.address_line_1 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.locality') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.address.locality }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.postal_code') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.address.postal_code }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t('pages.admin.order.country_code') }}
                                </td>
                                <td>
                                    {{ JSON.parse(tl.action_value).new_value.address.country_code }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-else-if="tl.action_type == 'vehicle_info_updated'">
                    <div class="n2-text-bold" style="color: red;">
                        <table v-if="JSON.parse(tl.action_value).previous_value">
                            <tr>
                                <td>{{ $t('pages.admin.order.registration_number') }}</td>
                                <td>{{ $t('pages.admin.order.make') }}</td>
                                <td>{{ $t('pages.admin.order.model') }}</td>
                                <!-- <td>{{ $t('pages.admin.order.color') }}</td> -->
                            </tr>
                            <tr v-for="(vehicle, tindex) in JSON.parse(tl.action_value).previous_value" v-bind:key="tindex">
                                <td>{{ vehicle.registration_number }}</td>
                                <td>{{ vehicle.make }}</td>
                                <td>{{ vehicle.model }}</td> 
                                <!-- <td>{{ vehicle.color }}</td> -->
                            </tr>
                        </table>
                    </div>
                    <div class="n2-text-bold">
                        <table v-if="JSON.parse(tl.action_value).new_value">
                            <tr>
                                <td>{{ $t('pages.admin.order.registration_number') }}</td>
                                <td>{{ $t('pages.admin.order.make') }}</td>
                                <td>{{ $t('pages.admin.order.model') }}</td>
                                <!-- <td>{{ $t('pages.admin.order.color') }}</td> -->
                            </tr>
                            <tr v-for="(vehicle, tindex) in JSON.parse(tl.action_value).new_value" v-bind:key="tindex">
                                <td>{{ vehicle.registration_number }}</td>
                                <td>{{ vehicle.make }}</td>
                                <td>{{ vehicle.model }}</td> 
                                <!-- <td>{{ vehicle.color }}</td> -->
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-else>
                    
                </div>
            </td>
        </tr>
    </table>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        props: ['timelines'],   
        computed: {
            ...mapGetters('globalization', {
                languages: 'languages',
            })
        },
        methods: {
            formatDate(date) {
                return new Date(date + 'Z').toLocaleString();
            },
            getOperatorType(operator_type) {
                switch (operator_type) {
                    case 'admin':
                        return this.$t('components.app.timelines.admin');
                    case 'customer':
                        return this.$t('components.app.timelines.customer');
                }
            },
            getOperatorName(tl) {
                if (tl.operator_type == 'admin') {
                    return tl.user.given_name + ' ' + tl.user.family_name;
                }
                else if (!tl.operator_id) {
                    return this.$t('components.app.timelines.anonymous');}
                else {
                    return this.$t('components.app.timelines.self');
                }
            },
            getActionDescription(action_type) {
                switch (action_type) {
                    case 'order_created':
                        return this.$t('components.app.timelines.order_created');
                    case 'note_added':
                        return this.$t('components.app.timelines.note_added');
                    case 'payment_recorded':
                        return this.$t('components.app.timelines.payment_recorded');
                    case 'order_canceled':
                        return this.$t('components.app.timelines.order_canceled');
                    case 'leg_canceled':
                        return this.$t('components.app.timelines.leg_canceled');
                    case 'contact_info_updated':
                        return this.$t('components.app.timelines.contact_info_updated');
                    case 'vehicle_info_updated':
                        return this.$t('components.app.timelines.vehicle_info_updated');
                    case 'ticket_email_sent':
                        return this.$t('components.app.timelines.ticket_email_sent');
                    case 'fee_applied':
                        return this.$t('components.app.timelines.fee_applied');
                    case 'leg_fee_applied':
                        return this.$t('components.app.timelines.leg_fee_applied');
                    case 'refund_issued':
                        return this.$t('components.app.timelines.refund_issued');
                }
            }
        }
    }
</script>

<style>
</style>
